import { useEffect, useState } from "react";
import { X, Lightbulb } from "lucide-react";

const TIPS = {
  chauffeur: [
    "Gagnez du temps lors de vos passages : tout ce qu'il y a à récupérer est regroupé par établissement.",
    "Réduisez les oublis : une PMT manquante se signale en quelques secondes.",
    "Une PMT pas prête ? Choisissez « Revenir plus tard » : la récupération se reprogramme automatiquement.",
    "Chaque document récupéré vous rapporte des points visibles dans « Mes points ».",
  ],
  regulation: [
    "Le tableau de bord distingue à récupérer aujourd'hui, en retard et à venir.",
    "Affectez plusieurs documents à un chauffeur qui passe déjà dans l'établissement.",
    "Les reports des chauffeurs reprogramment automatiquement les récupérations.",
    "L'historique conserve chaque tentative : rien n'est écrasé.",
  ],
  dirigeant: [
    "Mesurez l'efficacité de SanitDocs : documents récupérés, retards et points par chauffeur chaque mois.",
    "Les récompenses par paliers motivent les équipes sans gestion manuelle.",
    "Abonnement & facturation : formule, factures PDF et échéances au même endroit.",
  ],
};

// Infobulles courtes affichées une seule fois à l'ouverture d'une démo.
export function DemoTour() {
  const [profile, setProfile] = useState(() =>
    sessionStorage.getItem("sanitdocs_demo_tour_dismissed") ? null : localStorage.getItem("sanitdocs_demo_tour"));
  const [i, setI] = useState(0);
  useEffect(() => {
    const onStorage = () => {
      if (sessionStorage.getItem("sanitdocs_demo_tour_dismissed")) { setProfile(null); return; }
      setProfile(localStorage.getItem("sanitdocs_demo_tour")); setI(0);
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("sanitdocs-demo", onStorage);
    return () => { window.removeEventListener("storage", onStorage); window.removeEventListener("sanitdocs-demo", onStorage); };
  }, []);
  const tips = TIPS[profile];
  if (!tips) return null;
  const close = () => {
    localStorage.removeItem("sanitdocs_demo_tour");
    sessionStorage.setItem("sanitdocs_demo_tour_dismissed", "1");
    setProfile(null);
  };
  const next = () => (i + 1 >= tips.length ? close() : setI(i + 1));
  return (
    <div
      data-testid="demo-tour"
      className="fixed inset-x-0 mx-auto z-50 w-full rounded-2xl bg-brand-800 text-white shadow-2xl shadow-brand-900/40 p-4 pr-11 animate-fade-in"
      style={{ maxWidth: "min(28rem, calc(100vw - 32px))", bottom: "calc(env(safe-area-inset-bottom, 0px) + 5rem)" }}
    >
      <button
        data-testid="demo-tour-close"
        onClick={close}
        aria-label="Fermer le tour"
        className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full bg-white/15 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-accent-500/30 text-accent-200 flex items-center justify-center shrink-0"><Lightbulb className="w-5 h-5" /></div>
        <p className="text-sm flex-1 leading-snug" data-testid="demo-tour-text">{tips[i]}</p>
      </div>
      <div className="flex items-center justify-between gap-2 mt-3">
        <div className="flex gap-1 shrink-0">{tips.map((_, k) => <span key={k} className={`h-1.5 rounded-full ${k === i ? "w-5 bg-accent-300" : "w-1.5 bg-white/30"}`} />)}</div>
        <div className="flex items-center gap-3">
          <button data-testid="demo-tour-skip" onClick={close} className="text-xs font-semibold text-brand-200 hover:text-white underline underline-offset-2 whitespace-nowrap">Passer le tour</button>
          <button data-testid="demo-tour-next" onClick={next} className="text-xs font-bold px-3 py-1.5 rounded-lg bg-accent-500 hover:bg-accent-400 transition-colors whitespace-nowrap">{i + 1 >= tips.length ? "Terminer" : "Suivant"}</button>
        </div>
      </div>
    </div>
  );
}
